'use client';

import { useTranslations } from 'next-intl';

export const SectionTitleSeparator = () => {
  const t = useTranslations('directSale');

  return (
    <div className="mb-4 grid items-center grid-cols-[1fr_max-content_1fr] gap-6 ">
      <div className="border-b border-white/20" />
      <h2 className="text-white/60 text-[12px] font-bold uppercase text-center tracking-[0.25em]">{t('nowGoing')}</h2>
      <div className="border-b border-white/20" />
    </div>
  );
};
